// Container for FOBPriceByOriginChart that fetches price data
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import Colors from '../../../constants/Colors';
import PageSkeleton from '../../../components/PageSkeleton';
import FOBPriceByOriginChart from './FOBPriceByOriginChart';
import { useFobPriceByOriginData } from '../../../utils/api-hooks/analytics';

/**
 * Container component that fetches price data
 * for the FOBPriceByOriginChart
 *
 * Note: Seasonality is now a separate chart (FOBSeasonalityChartContainer)
 */
const FOBPriceByOriginChartContainer = ({ apiParams }) => {
  const { t } = useTranslation();
  const { email, commodity, dateStart, dateEnd } = apiParams || {};

  // Fetch price data
  const { fobPriceByOrigin, origins, years, filterOptions, isLoading, isError, error } = useFobPriceByOriginData(email, commodity, dateStart, dateEnd);

  // Loading state
  if (isLoading) {
    return <PageSkeleton shape="chart" />;
  }

  // Error state
  if (isError) {
    return (
      <div className="h-full w-full flex flex-col items-center justify-center gap-3 px-4">
        <AlertCircle
          size={32}
          style={{ color: Colors.error || '#ef4444' }}
        />
        <p className="text-gray-400 text-sm text-center">
          {error?.message || t('charts.errorLoading')}
        </p>
      </div>
    );
  }

  return (
    <FOBPriceByOriginChart
      commodity={commodity || ''}
      priceData={fobPriceByOrigin || []}
      origins={origins || []}
      filterOptions={filterOptions}
      years={(years || []).sort((a, b) => b - a)}
    />
  );
};

export default FOBPriceByOriginChartContainer;
